import { render, staticRenderFns } from "./user-and-company-edit-card.vue?vue&type=template&id=464a0adb&scoped=true"
import script from "./user-and-company-edit-card.vue?vue&type=script&lang=js"
export * from "./user-and-company-edit-card.vue?vue&type=script&lang=js"
import style0 from "./user-and-company-edit-card.vue?vue&type=style&index=0&id=464a0adb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464a0adb",
  null
  
)

export default component.exports